import store from '@core/store';
import BaseModel from '@core/model';
import { Auth } from '@core/auth';

export function findRequests(config) {
    return store.getters['requests/findAll'](config);
}

export async function addRequest(config) {
    return await store.dispatch('requests/add', config);
}

export function completeRequest(requestId, response = null) {
    return store.dispatch('requests/completed', { id: requestId, response });
}

export function rejectRequest(requestId, response = null) {
    return store.dispatch('requests/rejected', { id: requestId, response });
}

export function isAborted(requestId) {
    return store.getters['requests/aborted'](requestId);
}

export function cleanRequestData(v) {
    if (v === null) {
        return null;
    }

    if (typeof v === 'string') {
        return v;
    }

    if (typeof v === 'number') {
        return v;
    }

    if (typeof v === 'boolean') {
        return v;
    }

    if (v instanceof File) {
        return v;
    }

    if (v instanceof BaseModel) {
        v = v.$toPayload();
    }

    if (typeof v === 'object' && v && '$deleted' in v && v.$deleted) {
        return undefined;
    }

    if (Array.isArray(v)) {
        return v.map(v => cleanRequestData(v)).filter(v => v !== undefined);
    }

    if (typeof v === 'object' && v && 'amount' in v && 'currency' in v) {
        if (v.amount === null || v.amount === undefined) {
            return null;
        }
    }

    if (typeof v === 'object' && 'content' in v && Array.isArray(v.content) && !('type' in v)) {
        v.type = 'doc';
    }

    if (typeof v === 'object') {
        return Object.keys(v).reduce((acc, key) => {
            if (!key.startsWith('$') || key === '$deleted') {
                const clean = cleanRequestData(v[`${key}`]);
                if (clean !== undefined) {
                    acc[`${key}`] = clean;
                }
            }
            return acc;
        }, {});
    }

    return v;
}

export function attachHeaders(headers = {}) {
    return { ...headers, ...Auth().headers };
}
